/*
	InstaSlide
	Cross-fading image slideshow for Fox Restaurant Concepts

	_____________________________________________________

	USAGE

		var slideShow = new instaSlide('.target-element', options);

	OPTIONS

		timing
			Duration of image display before transition (set in miliseconds). Default is 7000 (7 seconds).

		paused
			Initialise the slideshow but don't autoplay it. Default is true.

		delay
			Delay autoplaying by this amount of time. Set in miliseconds. Default is 0.

		transition
			Duration of crossfade (set in miliseconds). Default is 1500 (1.5 seconds).

		ease
			Timing function for transition. Can be either a built-in CSS easing function or a custom one. Default is ease-in-out.
			For a full list of built-in CSS timing functions, see https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function


	METHODS

		slideShow.stop()
			Stops the slideshow at the currently displayed slide.

		slideShow.play()
			Starts the slideshow or resumes it if paused.

		slideShow.destroy()
			Destroys current instance of slideshow.
*/

var instaSlide = function(container, params) {

	if ('undefined' == typeof window.jQuery) { // Die if jQuery not found
		//console.log('jQuery not found. InstaSlide requires jQuery to work.');
		return false;
	}

	if (!(this instanceof instaSlide)) return new instaSlide(container, params);

	var defaults = {
		delay: 0,
		ease: 'ease-in-out',
		paused: true,
		timing: 7000,
		transition: 1500
	};

	params = params || {};
	for (var def in defaults) {
		if (typeof params[def] === 'undefined') {
			params[def] = defaults[def];
		}
	}

	var s = this;
	s.container = container;
	s.$container = jQuery(container);
	s.intervalId = undefined;

	if (s.$container.length === 0) { // Die if no container specified
		return;
	}

	s.setTransition = function(strSelector, intDuration) {
		var transitionHandler = [
			{
				'prop' : 'transition',
				'event' : 'transitionend'
			},
			{
				'prop' : 'MozTransition',
				'event' : 'transitionend'
			},
			{
				'prop' : 'WebkitTransition',
				'event' : 'webkitTransitionEnd'
			},
			{
				'prop' : 'OTransition',
				'event' : 'oTransitionEnd'
			},
			{
				'prop' : 'msTransition',
				'event' : 'MSTransitionEnd'
			}],
			transitionString = 'opacity '+ intDuration +'ms '+ params.ease,
			el = document.createElement('div');

		for (var i = 0; i < transitionHandler.length; i++) {
			if (transitionHandler[i].prop in el.style) {
				jQuery(strSelector).on(transitionHandler[i].event, function() {
					jQuery(strSelector).trigger('instaslide-transition-end');
				});

				jQuery(strSelector)[0].style[transitionHandler[i].prop] = transitionString;
			}
		}
	};

	s.stop = function() {
		if (!s.intervalId) return;
		if (s.intervalId) clearInterval(s.intervalId);
		if (s.timeoutId) clearTimeout(s.timeoutId);
	};

	s.play = function() {
		s.intervalId = setInterval(function() {
			s.$container.find('.instagram-item:first-child').css('opacity', 0).removeClass('active')
				.one('instaslide-transition-end', function() {
					jQuery(this).appendTo(s.$container);
				})
				.next(s.container +' .instagram-item').css('opacity', 1).addClass('active');
			s.setPermalink(s.$container.find('.instagram-item.active').attr('data-permalink'));
		}, params.timing);
	};

	s.destroy = function() {
		s.stop();
		s.$container.find('.instagram-item').removeAttr('style');
		s = null;
		return;
	};

	s.init = function() {
		s.$container.find('.instagram-item:first-child').addClass('active');
		s.setPermalink(s.$container.find('.instagram-item:first-child').attr('data-permalink'));
		s.$container.find('.instagram-item:gt(0)').css('opacity', 0);
		$(s.container + ' .instagram-item').each(function() {
			s.setTransition($(this), params.transition);
		});

		if (!params.paused) {
			s.timeoutId = setTimeout(function() { s.play(); }, params.delay);
		}

		return s;
	};

	s.setPermalink = function(permalink){
		s.$container.parent('a').attr('href', permalink);
	}

	s.init();
	window.instaSlide = instaSlide;
};